// src/components/WithSeo.js
import PageTitleManager from './PageTitleManager';

const WithSeo = ({ 
  children, 
  title = '', 
  description = '',
  keywords = '',
  ogImage = ''
}) => {
  return (
    <>
      <PageTitleManager 
        title={title}
        description={description}
        keywords={keywords}
        ogImage={ogImage}
      />
      {children}
    </>
  );
};

export default WithSeo;